import { useLocation } from "react-router-dom";
import { useQuery } from "~/hooks/useQuery";

export type MembershipSelectAction =
  | "extend"
  | "payment"
  | "resubscribe"
  | "upgrade";

export const useGetMembershipSelectAction = (): MembershipSelectAction => {
  const location = useLocation();
  const upgradeParams = useQuery().get("upgrade");
  const resubscribeParams = useQuery().get("resubscribe");
  const extendParams = useQuery().get("extend");
  const isUpgrade = !!location.state?.upgrade || !!upgradeParams;
  const isResubscribe = !!location.state?.resubscribe || !!resubscribeParams;
  const isExtend = !!location.state?.extend || !!extendParams;

  if (isUpgrade) return "upgrade";
  if (isResubscribe) return "resubscribe";
  if (isExtend) return "extend";

  return "payment";
};
